import { useEffect, useRef, useState } from "react";
import clsx from "clsx";
import { Icon } from "react-migration/components/Icon";

type LoadingIndicatorProps = {
  show?: boolean;
  className?: string;
  size?: "sm" | "md" | "lg";
};

export function LoadingIndicator({ show = false, className, size = "md" }: Readonly<LoadingIndicatorProps>) {
  const [shouldShow, setShouldShow] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout>();

  useEffect(
    function delayShow() {
      if (show) {
        timeoutRef.current = setTimeout(() => setShouldShow(true), 300);
      } else {
        setShouldShow(false);
      }

      return () => clearTimeout(timeoutRef.current);
    },
    [show]
  );

  return (
    <div
      className={clsx(className, "transition-opacity duration-300", {
        "opacity-100": shouldShow,
        "opacity-0": !shouldShow,
      })}
    >
      <Icon
        icon="icon-lt-loader-4-line"
        size={size}
        extraClasses="inline-block animate-spin origin-center text-blue-grey-400"
      />
    </div>
  );
}
